import { render } from "./First.vue?vue&type=template&id=4d31a13f&scoped=true"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"

import "./First.vue?vue&type=style&index=0&id=4d31a13f&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d31a13f"]])

export default __exports__